import { FC } from 'react';

import { HARDCODED_PRODUCT_RATE_DATA } from '@lib/core/service/consts';
import { TProductRateValue } from '@lib/core/users/slices/productRate';

import * as S from '@components/web/src/atoms/ProductRating/ProductRatingListItem/styles';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { Image } from '@components/web/src/foundations/Image/Image';
import { Text } from '@components/web/src/foundations/Text/Text';
import { COLORS } from '@components/web/src/styles';

interface IItem {
  productRate: TProductRateValue;
  isActive: boolean;
}

interface IProps extends IItem {
  onHandleClick: () => void;
}

export const ProductRateListItem: FC<IProps> = ({ productRate, isActive, onHandleClick }) => {
  const currentStarColor = isActive ? '#FFC800' : '#E0E2E7';
  return (
    <S.ProductRateListItemContainer
      $backgroundColor={HARDCODED_PRODUCT_RATE_DATA[productRate].colors.backgroundColor}
      $borderColor={HARDCODED_PRODUCT_RATE_DATA[productRate].colors.borderColor}
      $isActive={isActive}
      onClick={onHandleClick}
    >
      <Image
        alt="feedback"
        maxHeight="32px"
        maxWidth="32px"
        minHeight="32px"
        minWidth="32px"
        src={HARDCODED_PRODUCT_RATE_DATA[productRate].icon.activeIcon}
      />
      <Flexbox isFullWidth>
        <Text
          color={COLORS.gray[900]}
          size="body2"
          text={HARDCODED_PRODUCT_RATE_DATA[productRate].text}
          weight="medium"
        />
      </Flexbox>
      <Flexbox gap={2}>
        {new Array(5).fill(null).map((_, index) => (
          <svg key={index} fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.00008 1.16797L8.80258 4.81964L12.8334 5.4088L9.91675 8.24964L10.6051 12.263L7.00008 10.3671L3.39508 12.263L4.08341 8.24964L1.16675 5.4088L5.19758 4.81964L7.00008 1.16797Z"
              fill={HARDCODED_PRODUCT_RATE_DATA[productRate].value / 10 >= index + 1 ? currentStarColor : 'none'}
              stroke={isActive ? '#FFC800' : '#E0E2E7'}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ))}
      </Flexbox>
    </S.ProductRateListItemContainer>
  );
};
